import React from "react"
import ReactPhoneInput from "react-phone-number-input/react-hook-form"
import { FieldValues, Path, RegisterOptions, useFormContext } from "react-hook-form"
import "react-phone-number-input/style.css"
import styles from "./Forms.module.scss"
import cs from "classnames"
import { validatePhone } from "./utils"

export interface Props<TFieldValues extends FieldValues = FieldValues> {
  name: Path<TFieldValues>
  rules?: RegisterOptions
  className?: string
  placeholder?: string
  disabled?: boolean
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void
}

export const PhoneInput = <TFieldValues extends FieldValues = FieldValues>({
  name,
  rules = {},
  className,
  placeholder,
  disabled,
  onBlur,
}: Props<TFieldValues>) => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext()

  const error = errors[name]
  const hasValidationError = !!error
  const errorLabel = hasValidationError ? error.message?.toString() : undefined

  const showErrorLabel = hasValidationError && errorLabel

  return (
    <div className={cs(styles.phoneInputRoot, className)}>
      <ReactPhoneInput
        disabled={disabled}
        name={name}
        className={cs(styles.phoneInput, { [styles.phoneInputError]: hasValidationError })}
        placeholder={placeholder}
        defaultCountry="US"
        autoComplete={`tel-${name}`}
        control={control}
        rules={{ ...rules, validate: validatePhone }}
        onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => {
          clearErrors(name)
          onBlur?.(e)
        }}
      />
      {showErrorLabel && <span className={styles.errorLabel}>{errorLabel}</span>}
    </div>
  )
}
